import { combineReducers } from "redux";
import common from "./reducers/common.reducer";

export default combineReducers({
  common
});
